<template>
  <ValidationProvider
    v-slot="{ errors, valid }"
    :vid="vid"
    :mode="mode"
    :name="String(_uid)"
    :rules="rules"
  >
    <v-file-input
      v-model="innerValue"
      color="primary accent-4"
      :class="`${customClass} ${requiredClassByRules()}`"
      :error-messages="errors"
      :success="valid"
      v-bind="$attrs"
      :multiple="multiple"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
      v-on="$listeners"
      @change="fileUpload($event)"
    >
      <template v-slot:selection="{ index, text }">
        <v-chip color="primary accent-4" dark label small>
          {{ text }}
        </v-chip>
      </template>
    </v-file-input>
  </ValidationProvider>
</template>

<script>
import { validationMixin } from '../mixins/validation'

export default {
  mixins: [validationMixin],
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
    customClass: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'lazy',
    },
    vid: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: [],
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    fileUpload(event) {
      this.$emit('fileUpload', event)
    },
  },
}
</script>
